module.exports = __webpack_public_path__ + "static/media/Img_6.52a009ee.jpg";